//All available page names, mainly used for navigation or config purposes
export enum PageName {
  HOME = "home",
}